import { formatCountdown } from '@/utils/date';
import { Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

const useAdventCountdown = (targetDate: Date) => {
  const countdownDate = new Date(targetDate).getTime();
  const [countdown, setCountdown] = useState(countdownDate - new Date().getTime());
  const [hasExpired, setExpired] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const countdownValue = countdownDate - new Date().getTime();
      setCountdown(countdownValue);
      setExpired(countdownValue < 1000);
    }, 1000);

    return () => clearInterval(interval);
  }, [countdownDate]);

  return { hasExpired, countdown: formatCountdown(countdown) };
};

type Props = { date: Date };

export const AdventCountdown = ({ date }: Props) => {
  const {
    countdown: { hours, minutes, seconds },
    hasExpired,
  } = useAdventCountdown(date);

  return (
    <Text color="lightPurple" mb="space.10">
      {hasExpired ? 'This quest has expired.' : `Quest ends in ${hours}:${minutes}:${seconds}`}
    </Text>
  );
};
